import React from 'react'
import './Home.css'

function Home() {
  return (
    <div className='dreaming'>OTengnér,  "Let's Bring your ideas to life, together!"</div>
  )
}

export default Home